import { CheckCircle2, TrendingUp, Home, Calendar, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SolutionSection() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = [
    {
      icon: TrendingUp,
      title: "10% Rental Income Dubai",
      description: "Achieve the best rental yield in Dubai with a target of 10%+ rental income. This is a prime USD investment in Dubai, offering a stable, passive income stream.",
      highlight: "Target Returns"
    },
    {
      icon: Home,
      title: "Affordable Dubai Property",
      description: "This affordable Dubai property starts at just $250,000, making it an accessible Dubai apartment investment for a wide range of investors.",
      highlight: "From $250,000"
    },
    {
      icon: Calendar,
      title: "Dubai Property Payment Plan",
      description: "With our flexible Dubai property payment plan, you only need a 20% down payment to secure your Dubai residential investment.",
      highlight: "20% Down Payment"
    },
    {
      icon: Users,
      title: "Dubai Golden Visa Property",
      description: "This Dubai Golden Visa property is more than just an investment; it's a gateway to a new life. Enjoy a thriving community and secure your family's future in Dubai.",
      highlight: "40+ Amenities"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              The Solution: A High ROI Dubai Real Estate Investment
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              This is the ultimate Dubai investment opportunity. A tax-free property in Dubai that offers high returns and is perfect for international investors. Whether you're an expat looking for property in Dubai or an international investor, this is your chance to enter the lucrative Dubai property market.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div 
                  key={index}
                  className="bg-card border border-border rounded-lg p-8 hover:shadow-lg transition-shadow"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-7 h-7 text-primary" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="text-2xl font-bold text-card-foreground">{benefit.title}</h3>
                      </div>
                      <div className="inline-block px-3 py-1 bg-accent/20 text-accent-foreground rounded-full text-sm font-semibold mb-3">
                        {benefit.highlight}
                      </div>
                      <p className="text-muted-foreground leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-8 md:p-12 border border-primary/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex-1">
                <h3 className="text-3xl font-bold mb-3 text-foreground">
                  Start Your Dubai Real Estate Investment Journey
                </h3>
                <p className="text-lg text-muted-foreground">
                  Find your perfect Dubai property for sale. Get your free guide and consultation now.
                </p>
              </div>
              <Button 
                size="lg" 
                className="text-lg px-8 py-6 whitespace-nowrap"
                onClick={scrollToForm}
              >
                Get Started Now
              </Button>
            </div>
          </div>

          {/* Key Investment Highlights */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-muted/30 rounded-lg">
              <div className="text-3xl font-bold text-primary mb-2">10%+</div>
              <div className="text-sm text-muted-foreground">Annual Rental Yield</div>
            </div>
            <div className="text-center p-6 bg-muted/30 rounded-lg">
              <div className="text-3xl font-bold text-primary mb-2">$250K</div>
              <div className="text-sm text-muted-foreground">Starting Price</div>
            </div>
            <div className="text-center p-6 bg-muted/30 rounded-lg">
              <div className="text-3xl font-bold text-primary mb-2">20%</div>
              <div className="text-sm text-muted-foreground">Down Payment</div>
            </div>
            <div className="text-center p-6 bg-muted/30 rounded-lg">
              <div className="text-3xl font-bold text-primary mb-2">0%</div>
              <div className="text-sm text-muted-foreground">Property Tax</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
